<div
  [ngStyle]="{ 'background-image': 'url(' + img + ')' }"
  style="
    width: 600px;
    height: 1900px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: 100%;
  "
  class="zoom"
>
  <button
    class="btn btn-sm setAv"
    *ngFor="let x of seats"
    title="{{ x.booked_user }}"
    [ngStyle]="{ margin: x.xy }"
    (click)="openModal(x)"
    [ngClass]="{
      'btn-warning': x.is_fixed == 1,
      cstmClr: x.is_disabled == 1,
      'btn-danger': x.is_flexible_seat == 1,
      cstmInfoclr: x.is_booked == true,
      cstmBlockedclr: x.is_blocked == true
    }"
  >
    {{ x.seat_id }}
  </button>
</div>
